import React, { useEffect, useState } from 'react'
import Field, { DjangoField } from 'championship/src/components/Fields/Field'
import { useAction, useAtom, useCtx } from '@reatom/npm-react'
// import { isSingleAtom } from '../model'
import { 
    initialSchemaAtom, 
    isAnnonceAtom, 
    saveAction,
    cancelAction,
    modelStore,
    changeTabAction,
    getModel,
    getModelSchema,
    getModelAtom,
    tournamentIdAtom,
} from '../../model'
import {checkTabValidation, usePreventValidation} from '../utils'
import { action } from '@reatom/core'
// import { installTabValidation } from './utils'

function TabCommon({ model }){
    
    const {prevent_validation} = usePreventValidation()

    const ctx = useCtx()
    const tab_model = getModel(model)
    const tab = tab_model.schema
    const [tab_state, setTabState] = useAtom(tab_model.atom)
    const [tournament_id, setTournamentIdAtom] = useAtom(tournamentIdAtom)

    // useEffect(() => {
    //     setTimeout(()=>{
    //         preventValidationAtom(ctx, false)
    //     }, 1000)
    // }, [])

    // let validation_unsubscribes = []

    // useEffect(() => {
    //     validation_unsubscribes = installTabValidation(ctx, model, {
    //         'tournament.title': {},
    //         'tournament.date_date': {},
    //         'tournament.date_time': {}
    //     })
    // }, [])

    const [is_annonce, setAnnonce] = useAtom(getModelAtom('settings.annonce'))

    const [competition_format, ] = useAtom(getModelAtom('annonce:tournament.competition_format'))

    const [allow_requests, set_allow_requests] = useAtom(getModelAtom('tournament.allow_requests'))

    const model_allow_requests = getModel('tournament.allow_requests')

    let is_allow_requests_disabled
    if(competition_format === 'singal' || competition_format === ''){
        is_allow_requests_disabled = false
        model_allow_requests.messages_atom(ctx, [])
    }else{
        is_allow_requests_disabled = true
        set_allow_requests(false)
        model_allow_requests.messages_atom(ctx, [{
            text: 'Заявки на данный формат участия не возможны'
        }])
    }

    return (
        <div className="reactive-form-tab-body" ref={tab.ref_body}>
            <div className="reactive-form-tab-body__inner">
                <div className="f-row">
                    <div className="f-col f-col-lg-3 f-col-12">
                        <div className="page-heading -underline">
                            Общая информация
                        </div>
                    </div>
                    <div className="f-col f-col-lg-9 f-col-12">
                        <div className="f-row f-g-4">
                            <div className="f-col f-col-12">
                                <div className="f-row f-g-4">
                                    <div className="f-col f-col-12">
                                        <div className="reactive-form-flex-row">
                                            {/* <Field
                                                schema_key="annonce"
                                                required={true}
                                                type="switch"
                                                name="announce"
                                                id="announce"
                                                label="Создать анонс"
                                                ctx={ctx}
                                                // atom={isAnnonceAtom}
                                                /> */}
                                            <DjangoField
                                                // src={initial_schema.title}
                                                model="settings.annonce"
                                                label="Создать анонс" 
                                                ctx={ctx}
                                                />
                                            {/* <DjangoField
                                                model="settings.annonce"
                                                ctx={ctx}
                                                /> */}
                                            {is_annonce && (
                                                // <Field 
                                                //     required={true}
                                                //     type="switch"
                                                //     name="accept"
                                                //     id="accept"
                                                //     label="Принимать заявки" 
                                                //     />
                                                <DjangoField
                                                    // src={initial_schema.title}
                                                    model="tournament.allow_requests"
                                                    label="Принимать заявки"
                                                    disabled={is_allow_requests_disabled} 
                                                    ctx={ctx}
                                                    />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="f-col f-col-12">
                                <div className="f-row f-g-4">
                                    <div className="f-col f-col-lg-6 f-col-12">
                                        {/* <Field 
                                            required={true}
                                            type="text"
                                            name="title"
                                            id="title"
                                            label="Заголовок турнира" 
                                            /> */}
                                        <DjangoField
                                            // src={initial_schema.title}
                                            model="tournament.title"
                                            label="Заголовок турнира"
                                            ctx={ctx}
                                            />
                                    </div>
                                    <div className="f-col f-col-lg-4 f-col-12">
                                        {/* <Field 
                                            required={true}
                                            type="date" 
                                            name="date"
                                            id="date"
                                            label="Дата"
                                            max='2025-06-30'
                                            /> */}
                                        <DjangoField 
                                            // src={initial_schema.date_date}
                                            model="tournament.date_date"
                                            ctx={ctx}
                                            label="Дата"
                                            // label="Дата"
                                            />
                                    </div>
                                    <div className="f-col f-col-lg-2 f-col-12">
                                        {/* <Field 
                                            required={true}
                                            type="time" 
                                            name="time"
                                            id="time"   
                                            label="Время"
                                            /> */}
                                        <DjangoField 
                                            // src={initial_schema.date_time}
                                            model="tournament.date_time"
                                            ctx={ctx}
                                            label="Время"
                                            />
                                    </div>
                                </div>
                            </div>
                            {is_annonce && (
                                <div className="f-col f-col-12">
                                    <div className="f-row f-g-4">
                                        <div className="f-col f-col-lg-6 f-col-12">
                                            <DjangoField
                                                model='annonce:tournament.type_game'
                                                label="Дисциплина"
                                                required={false}
                                                ctx={ctx}
                                                />
                                        </div>
                                        <div className="f-col f-col-lg-6 f-col-12">
                                            <DjangoField
                                                model='annonce:tournament.competition_format'
                                                label="Формат участия"
                                                // required={false}
                                                ctx={ctx}
                                                />
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="f-col f-col-12">
                                <div className="f-row f-g-4 f-gy-2">
                                    <div className="f-col f-col-lg-6 f-col-12">
                                        <DjangoField 
                                            model="tournament.preview_text"
                                            ctx={ctx}
                                            type="default"
                                            label="Описание турнира"
                                            // src={initial_schema.preview_text}
                                            // type="default"
                                            />
                                    </div>
                                    <div className="f-col f-col-lg-6 f-col-12">
                                        <DjangoField 
                                            model="tournament.place"
                                            ctx={ctx}
                                            type="default"
                                            label="Место проведения"
                                            // src={initial_schema.place}
                                            // type="default"
                                            />
                                    </div>
                                    <div class="f-col f-col-12">
                                        {/* <DjangoField 
                                            model="tournament.stream_link"
                                            ctx={ctx}
                                            label="Ссылка на трансляцию"
                                            /> */}
                                        <DjangoField 
                                            model="tournament.youtube_id"
                                            ctx={ctx}
                                            label="Ссылка на трансляцию YouTube"
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="reactive-form-buttons">
                <button className="button" onClick={() => {
                    cancelAction(ctx)
                }}>
                    Отменить
                </button>
                {is_annonce && (
                    <button
                        className="button -fill"
                        // onClick={() => {saveAction(ctx)}}
                        onClick={() => {
                            if(tab_state.is_done){
                                // changeTabAction(ctx, 1)
                                saveAction(ctx)
                            } 
                        }}
                        onMouseEnter={()=>{checkTabValidation(ctx, tab_model)}}
                        disabled={!tab_state.is_done}
                    >
                        
                        {tournament_id && (
                            'Редактировать анонс'
                        ) || (
                            'Создать анонс'
                        )}
                    </button>
                )}
                {!is_annonce && (
                    <div 
                        className="button -fill"
                        // onClick={() => {changeTabAction(ctx, 1)}}
                        onClick={() => {
                            if(tab_state.is_done){
                                // changeTabAction(ctx, 1)
                                changeTabAction(ctx, 1)
                            } 
                        }}
                        onMouseEnter={()=>{
                            if(!prevent_validation){
                                checkTabValidation(ctx, tab_model)
                            }
                        }}
                        disabled={!tab_state.is_done}
                    >
                        Далее
                    </div>
                )}
            </div>
        </div>
    )
}

export default TabCommon